/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Open360RetailerApiContractPhysicalProductSpecialOfferResourceModel } from './open360RetailerApiContractPhysicalProductSpecialOfferResourceModel';
import { IProductVariationIngredient } from './products/IProductVariationIngredient';

export interface Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation {
    ID?: string;
    SKU?: string;
    Size?: string;
    Color?: string;
    Price?: number;
    OldPrice?: number;
    /**
     * 0 = NoBadge, 1 = New, 2 = LimitedOffer, 4 = HotDeal, 8 = SaleEndingSoon, 16 = ClearanceSale, 32 = NewCollection, 64 = Sale
     */
    Badges?: Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation.BadgesEnum;
    ImagesID?: string[];
    Ingredients?: IProductVariationIngredient[];
    IsArchived?: boolean;
    NeckSize?: string;
    ChestSize?: string;
    BustSize?: string;
    WaistSize?: string;
    HipsSize?: string;
    InsideLegSize?: string;
    ShoeSize?: string;
    LegLengthSize?: string;
    DressSize?: string;
    Discount?: number;
    VAT?: number;
    InsidePrice?: number;
    InsideVAT?: number;
    IsHot?: boolean;
    PreparationTime?: number;
    SpecialOffer?: Open360RetailerApiContractPhysicalProductSpecialOfferResourceModel;
    StockQuantity?: number;
    Attachment?: IVariationAttachment;
    IsAccessibleOutOfSession?: boolean;
}
export namespace Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation {
    export type BadgesEnum = 0 | 1 | 2 | 4 | 8 | 16 | 32 | 64;
    export const BadgesEnum = {
        NUMBER_0: 0 as BadgesEnum,
        NUMBER_1: 1 as BadgesEnum,
        NUMBER_2: 2 as BadgesEnum,
        NUMBER_4: 4 as BadgesEnum,
        NUMBER_8: 8 as BadgesEnum,
        NUMBER_16: 16 as BadgesEnum,
        NUMBER_32: 32 as BadgesEnum,
        NUMBER_64: 64 as BadgesEnum
    }
}

export interface IVariationAttachment {
    ID: string;
    FileName: string;
    FileSize?: number;
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation.ts